import { faLinkedin, faQuora, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faThumbsUp } from '@fortawesome/free-regular-svg-icons'
import { faBox, faEyeLowVision, faFilePen, faGear, faPenNib } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import emailjs from '@emailjs/browser';
import React, { useRef, useState } from 'react'





function Header() {




  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  
  const form = useRef();
  
  function sendEmail(e){
      e.preventDefault();
  
  const templatePrams = {
     from_name: name,
     message: message,
     email: email
  }
  
     emailjs.send("service_65cprrq", "template_umixu3p", templatePrams,"aQpqjXho-KsvlXTMO" )
     .then((response) => {
       console.log("EMAIL ENVIANDO", response.status, response.text)
       setName('')
       setEmail('')
       setMessage('')
     }, (err) => {
      console.log("ERRO", err)
     })
  }


  return (
    <div className=''>


<div class="preloader">
  <div class="lds-ellipsis">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>



<div id="main-wrapper"> 
  
 
  <header id="header"> 
    
    <nav class="primary-menu navbar navbar-expand-md bg-transparent border-bottom-0">
      <div class="container position-relative">
        <div class="col-auto col-lg-2"> 
         
          <a class="logo" href="index.html" title="Zoon"> <img src="image/logo.png" class="logo1" alt="Zoon"/> </a> 
          
        </div>
        <div class="col navbar-accordion px-0">
          <button class="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#header-nav"><span></span><span></span><span></span></button>
          <div id="header-nav" class="collapse navbar-collapse justify-content-end">
            <ul class="navbar-nav">
              <li class="nav-item"><a class="nav-link" data-bs-toggle="modal" data-bs-target="#about" href="#">私たちについて</a></li>
            </ul>
          </div>
        </div>
        <div class="col-auto d-flex justify-content-end">
          <ul class="social-icons">
            <li class="social-icons-twitter"><a data-bs-toggle="tooltip" href="https://twitter.com/ClaudioFragao1" target="_blank" title="Twitter"><FontAwesomeIcon icon={faTwitter} /></a></li>
            <li class="social-icons-facebook"><a data-bs-toggle="tooltip" href="https://www.linkedin.com/in/claudio-fragao-792889a9/" target="_blank" title="Linkedin"><FontAwesomeIcon icon={faLinkedin} /></a></li>
            <li class="social-icons-instagram"><a data-bs-toggle="tooltip" href="https://pt.quora.com/profile/Claudio-Fragao" target="_blank" title="Quora"><FontAwesomeIcon icon={faQuora} /></a></li>
          </ul>
        </div>
      </div>
    </nav>
   
  </header>
  
  
  
      <div class="container py-4 py-lg-0">
        <div class="row min-vh-100"> 
          
         
          <div class="col-lg-8 align-items-center d-flex flex-column py-5">
              <div class="row py-5 my-auto text-center text-lg-start">
                <div class="col-12 mx-auto">
                  <h1 class="text-9 text-white bg-danger d-inline-block fw-700 rounded px-3 py-2 mb-4">もうすぐだ！</h1>
                  <h2 class="text-15 fw-600 mb-4">私たちの新しいウェブサイトは準備中です.</h2>
                </div>
                <div class="col-md-8 col-lg-9 col-xl-8 mx-auto me-lg-auto ms-lg-0">
                  <p class="text-5 text-muted mb-3">発売時に通知を受け取る.</p>
                  
			  <div class="subscribe-form">
			 
			  <div class="subscribe-form-result mt-3"></div>
			  </div>
            
                </div>
              </div>
          </div>
          
          <div class="col-lg-4 my-auto py-lg-5">
            <div class="row bg-light rounded shadow-md border text-center mx-0 py-4 mb-4 mb-lg-0">
              <div class="col-11 mx-auto">
                <h3 class="fw-600 mb-3 mt-3">お問合せ</h3>
                <p class="text-black-50 mb-4">カスタマーサポートについては、メモをお送りください。</p>
                
                <form ref={form} onSubmit={sendEmail} id="contact-form">
                  <div class="mb-3">
                    <input type="text" name="setName" onChange={(e) => setName(e.target.value)} class="form-control border-2" placeholder="名前を入力" value={name} required />
                  </div>
                  <div class="mb-3">
                    <input  type="email" name="setEmail" onChange={(e) => setEmail(e.target.value)} class="form-control border-2" placeholder="Eメールを入力" value={email} required />
                  </div>
                  <div class="mb-3">
                    <textarea  name="setMessage" onChange={(e) => setMessage(e.target.value)} class="form-control border-2" rows="2" placeholder="クエリーの入力" value={message} required ></textarea>
                  </div>
                  <div class="d-grid mt-4">
                    <button id="submit-btn" class="btn btn-primary" type="submit">メッセージを送る</button>
                  </div>
                </form>

                
              </div>
            </div>
          </div>
  
        </div>
      </div>
</div>



<div id="about" class="modal fade" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fw-600 text-7 mx-auto">私たちについて</h5>
        <button type="button" class="btn-close ms-0" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body p-4">
        <p class="lead text-center"> 
          EcoiEnv

         Webアプリケーション開発、人工知能AIアプリに焦点を当てています。
         JavaScriptを使用して。 我々は提供しています
         教育、金融、電子商取引、ソーシャルメディア、ヘルスケアなど、さまざまな分野のソフトウェア開発におけるエンドツーエンドの支援。
         当社は、Web アプリケーション レベルの脆弱性攻撃、Web サーバーの悪用を含む AI アプリケーション、OWASP 攻撃、XSS、SQL インジェクションに対して取り組んでいます。
        </p>
        <div class="row">
          <div class="col-lg-4">
            <div class="featured-box text-center">
              <div class="featured-box-icon text-primary"> <FontAwesomeIcon icon={faFilePen} /></div>
              <h4 class="fw-600">要件の収集</h4>
              <p class="text-3">私たちは、まず第一に、要件、リソース、情報を収集することを優先し、プロジェクトを開始する。</p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="featured-box text-center">
              <div class="featured-box-icon text-primary"> <FontAwesomeIcon icon={faPenNib} /></div>
              <h4 class="fw-600">UI/UXデザイン</h4>
              <p class="text-3">私たちは、最新のデザインツールを使って、キャッチーで魅力的なデザインを作成し、最高のユーザーフレンドリーな体験を提供します。</p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="featured-box text-center">
              <div class="featured-box-icon text-primary"> <FontAwesomeIcon icon={faBox} /></div>
              <h4 class="fw-600">プロトタイプ</h4>
              <p class="text-3">デザイン後、プロトタイプが完成し、製品の開発プロセスに送られます。</p>
            </div>
          </div>
        </div>
		
		<hr class="my-5"/>
		
		
		<h3 class="text-center my-5">最近のプロジェクト</h3>
		<div class="portfolio popup-img-gallery">
          <div class="row g-4">
            <div class="col-sm-6 col-lg-4">
              <div class="portfolio-box rounded">
                <div class="portfolio-img rounded"> <img class="img-fluid d-block" src="image/Untitleyd.png" alt=""/>
                  <div class="portfolio-overlay"> <a class="popup-img stretched-link" href="image/Untitleyd.png"></a>
                    <div class="portfolio-overlay-details">
                      <h5 class="text-white fw-400">プロジェクト名</h5>
                      <span class="text-light">カテゴリー</span> </div>
                  </div>
                </div>
              </div>
            </div>
			<div class="col-sm-6 col-lg-4">
              <div class="portfolio-box rounded">
                <div class="portfolio-img rounded"> <img class="img-fluid d-block" src="image/original-6216d481.png" alt=""/>
                  <div class="portfolio-overlay"> <a class="popup-img stretched-link" href="image/original-6216d481.png"></a>
                    <div class="portfolio-overlay-details">
                      <h5 class="text-white fw-400">プロジェクト名</h5>
                      <span class="text-light">カテゴリー</span> </div>
                  </div>
                </div>
              </div>
            </div>
			<div class="col-sm-6 col-lg-4">
              <div class="portfolio-box rounded">
                <div class="portfolio-img rounded"> <img class="img-fluid d-block" src="image/original-380baa1.jpg" alt=""/>
                  <div class="portfolio-overlay"> <a class="popup-img stretched-link" href="image/original-380baa1.jpg"></a>
                    <div class="portfolio-overlay-details">
                      <h5 class="text-white fw-400">プロジェクト名</h5>
                      <span class="text-light">カテゴリー</span> </div>
                  </div>
                </div>
              </div>
            </div>
			<div class="col-sm-6 col-lg-4">
              <div class="portfolio-box rounded">
                <div class="portfolio-img rounded"> <img class="img-fluid d-block" src="images/intro-bg-5.jpg" alt=""/>
                  <div class="portfolio-overlay"> <a class="popup-img stretched-link" href="images/intro-bg-5.jpg"></a>
                    <div class="portfolio-overlay-details">
                      <h5 class="text-white fw-400">Project Title</h5>
                      <span class="text-light">Category</span> </div>
                  </div>
                </div>
              </div>
            </div>
			<div class="col-sm-6 col-lg-4">
              <div class="portfolio-box rounded">
                <div class="portfolio-img rounded"> <img class="img-fluid d-block" src="images/intro-bg-6.jpg" alt=""/>
                  <div class="portfolio-overlay"> <a class="popup-img stretched-link" href="images/intro-bg-6.jpg"></a>
                    <div class="portfolio-overlay-details">
                      <h5 class="text-white fw-400">Project Title</h5>
                      <span class="text-light">Category</span> </div>
                  </div>
                </div>
              </div>
            </div>
			<div class="col-sm-6 col-lg-4">
              <div class="portfolio-box rounded">
                <div class="portfolio-img rounded"> <img class="img-fluid d-block" src="images/intro-bg.jpg" alt=""/>
                  <div class="portfolio-overlay"> <a class="popup-img stretched-link" href="images/intro-bg.jpg"></a>
                    <div class="portfolio-overlay-details">
                      <h5 class="text-white fw-400">Project Title</h5>
                      <span class="text-light">Category</span> </div>
                  </div>
                </div>
              </div>
            </div>
		</div>
		</div>
      </div>
    </div>
  </div>
</div>


    </div>
  )
}

export default Header